import {
    CHANGE_VALUE_PROPOSITION_STATE,
    CHANGE_VALUE_PROPOSITION_STATE_FAILED,
    CHANGE_VALUE_PROPOSITION_STATE_SUCCESS,
    CLEAR_SELECTED_VALUE_PROPOSITION,
    CLEAR_VALUE_PROPOSITION_LIST,
    DELETE_VALUE_PROPOSITION,
    DELETE_VALUE_PROPOSITION_FAILED,
    DELETE_VALUE_PROPOSITION_SUCCESS,
    DUPLICATE_VALUE_PROPOSITION,
    DUPLICATE_VALUE_PROPOSITION_FAILED,
    DUPLICATE_VALUE_PROPOSITION_SUCCESS,
    FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID,
    FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID_FAILED,
    FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID_SUCCESS,
    FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID,
    FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID_FAILED,
    FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID_SUCCESS,
    FETCH_VALUE_PROPOSITION_BY_ID,
    FETCH_VALUE_PROPOSITION_BY_ID_FAILED,
    FETCH_VALUE_PROPOSITION_BY_ID_SUCCESS,
    FETCH_VALUE_PROPOSITION_BY_SHARED_KEY,
    FETCH_VALUE_PROPOSITION_BY_SHARE_KEY,
    FETCH_VALUE_PROPOSITION_BY_SHARED_KEY_FAILED,
    FETCH_VALUE_PROPOSITION_BY_SHARED_KEY_SUCCESS,
    LOAD_VALUE_PROPOSITIONS_LIST,
    LOAD_VALUE_PROPOSITIONS_LIST_FAILED,
    LOAD_VALUE_PROPOSITIONS_LIST_SUCCESS,
    SAVE_VALUE_PROPOSITION,
    SAVE_VALUE_PROPOSITION_FAILED,
    SAVE_VALUE_PROPOSITION_SUCCESS,
    PREPARE_FOR_DOWNGRADE,
    PREPARE_FOR_DOWNGRADE_SUCCESS,
    PREPARE_FOR_DOWNGRADE_FAILED,
    GET_USER_OWNED_VPS,
    GET_USER_OWNED_VPS_SUCCESS,
    GET_USER_OWNED_VPS_FAILED,
    BULK_UPDATE_VP_KEEP_STATUS,
    BULK_UPDATE_VP_KEEP_STATUS_SUCCESS,
    BULK_UPDATE_VP_KEEP_STATUS_FAILED,
    RESET_VP_SHARE_KEY_SUCCESS
} from './constants';

export type ValuePropositionsAction = {
    type: string;
    payload: {} | string;
};

export const clearSelectedValueProposition =(): ValuePropositionsAction => ({
    type: CLEAR_SELECTED_VALUE_PROPOSITION,
    payload: null,
});

export const clearValuePropositionList =(): ValuePropositionsAction => ({
    type: CLEAR_VALUE_PROPOSITION_LIST,
    payload: null,
});

export const loadValuePropositionsList = (): ValuePropositionsAction => ({
    type: LOAD_VALUE_PROPOSITIONS_LIST,
    payload: null,
});

export const loadValuePropositionsListSuccess = (vpList): ValuePropositionsAction => ({
    type: LOAD_VALUE_PROPOSITIONS_LIST_SUCCESS,
    payload: vpList,
});

export const loadValuePropositionsListFailed = (error: string): ValuePropositionsAction => ({
    type: LOAD_VALUE_PROPOSITIONS_LIST_FAILED,
    payload: error,
});

export const duplicateValueProposition = (vpId, clientId): ValuePropositionsAction => ({
    type: DUPLICATE_VALUE_PROPOSITION,
    payload: { vpId, clientId },
});

export const duplicateValuePropositionSuccess = (): ValuePropositionsAction => ({
    type: DUPLICATE_VALUE_PROPOSITION_SUCCESS,
    payload: null,
});

export const duplicateValuePropositionFailed = (error: string): ValuePropositionsAction => ({
    type: DUPLICATE_VALUE_PROPOSITION_FAILED,
    payload: error,
});

export const fetchValuePropositionById = (vpId): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_ID,
    payload: { vpId },
});

export const fetchValuePropositionByIdSuccess = (vp): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_ID_SUCCESS,
    payload: { vp },
});

/** `failure` is the failed response (`{ status, body }`) so pages can pick the error text. */
export const fetchValuePropositionByIdFailed = (error: string, failure = { status: 500 }): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_ID_FAILED,
    payload: error,
    failure,
});

// Invite Link read. `via` is passed through from the address (only `vpx` counts).
export const fetchValuePropositionBySharedKey = (sharedKey, via): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_SHARED_KEY,
    payload: { sharedKey, via },
});

// Share Link read. Lands in the same sharedVp state (and SHARED_KEY success/failed
// actions) as the Invite Link read, since both return the same public model.
export const fetchValuePropositionByShareKey = (shareKey, via): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_SHARE_KEY,
    payload: { shareKey, via },
});

export const fetchValuePropositionBySharedKeySuccess = (vp): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_SHARED_KEY_SUCCESS,
    payload: { vp },
});

// `status` is the read's HTTP status (or the body's), null when it never reached the server.
export const fetchValuePropositionBySharedKeyFailed = (message, status = null): ValuePropositionsAction => ({
    type: FETCH_VALUE_PROPOSITION_BY_SHARED_KEY_FAILED,
    payload: { message, status },
});

export const saveValueProposition = (vp): ValuePropositionsAction => ({
    type: SAVE_VALUE_PROPOSITION,
    payload: { vp },
});

export const saveValuePropositionSuccess = (vpId, clientId): ValuePropositionsAction => ({
    type: SAVE_VALUE_PROPOSITION_SUCCESS,
    payload: { vpId, clientId },
});

export const saveValuePropositionFailed = (error: string): ValuePropositionsAction => ({
    type: SAVE_VALUE_PROPOSITION_FAILED,
    payload: error,
});

export const changeValuePropositionState = (vpId, isActive): ValuePropositionsAction => ({
    type: CHANGE_VALUE_PROPOSITION_STATE,
    payload: { vpId, isActive },
});

export const changeValuePropositionStateSuccess = (): ValuePropositionsAction => ({
    type: CHANGE_VALUE_PROPOSITION_STATE_SUCCESS,
    payload: null,
});

export const changeValuePropositionStateFailed = (error: string): ValuePropositionsAction => ({
    type: CHANGE_VALUE_PROPOSITION_STATE_FAILED,
    payload: error,
});

export const deleteValueProposition = (vpId): ValuePropositionsAction => ({
    type: DELETE_VALUE_PROPOSITION,
    payload: { vpId },
});

export const deleteValuePropositionSuccess = (): ValuePropositionsAction => ({
    type: DELETE_VALUE_PROPOSITION_SUCCESS,
    payload: null,
});

export const deleteValuePropositionFailed = (error: string): ValuePropositionsAction => ({
    type: DELETE_VALUE_PROPOSITION_FAILED,
    payload: error,
});

export const fetchFollowersByValuePropositionId = (vpId): ValuePropositionsAction => ({
    type: FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID,
    payload: { vpId },
});

export const fetchFollowersByValuePropositionIdSuccess = (followers): ValuePropositionsAction => ({
    type: FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID_SUCCESS,
    payload: { followers },
});

export const fetchFollowersByValuePropositionIdFailed = (error: string): ValuePropositionsAction => ({
    type: FETCH_FOLLOWERS_BY_VALUE_PROPOSITION_ID_FAILED,
    payload: error,
});

export const fetchAttachmentsByValuePropositionId = (vpId): ValuePropositionsAction => ({
    type: FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID,
    payload: { vpId },
});

export const fetchAttachmentsByValuePropositionIdSuccess = (attachments): ValuePropositionsAction => ({
    type: FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID_SUCCESS,
    payload: { attachments },
});

export const fetchAttachmentsByValuePropositionIdFailed = (error: string): ValuePropositionsAction => ({
    type: FETCH_ATTACHMENTS_BY_VALUE_PROPOSITION_ID_FAILED,
    payload: error,
});

/* VP DOWNGRADE SELECTION ACTIONS */
export const prepareForDowngrade = (): ValuePropositionsAction => ({
    type: PREPARE_FOR_DOWNGRADE,
    payload: null,
});

export const prepareForDowngradeSuccess = (): ValuePropositionsAction => ({
    type: PREPARE_FOR_DOWNGRADE_SUCCESS,
    payload: null,
});

export const prepareForDowngradeFailed = (error: string): ValuePropositionsAction => ({
    type: PREPARE_FOR_DOWNGRADE_FAILED,
    payload: error,
});

export const getUserOwnedVPs = (): ValuePropositionsAction => ({
    type: GET_USER_OWNED_VPS,
    payload: null,
});

export const getUserOwnedVPsSuccess = (vps): ValuePropositionsAction => ({
    type: GET_USER_OWNED_VPS_SUCCESS,
    payload: { vps },
});

export const getUserOwnedVPsFailed = (error: string): ValuePropositionsAction => ({
    type: GET_USER_OWNED_VPS_FAILED,
    payload: error,
});

export const bulkUpdateVPKeepStatus = (vps): ValuePropositionsAction => ({
    type: BULK_UPDATE_VP_KEEP_STATUS,
    payload: { vps },
});

export const bulkUpdateVPKeepStatusSuccess = (): ValuePropositionsAction => ({
    type: BULK_UPDATE_VP_KEEP_STATUS_SUCCESS,
    payload: null,
});

export const bulkUpdateVPKeepStatusFailed = (error: string): ValuePropositionsAction => ({
    type: BULK_UPDATE_VP_KEEP_STATUS_FAILED,
    payload: error,
});

export const resetVpShareKeySuccess = (vpId, shareKey): ValuePropositionsAction => ({
    type: RESET_VP_SHARE_KEY_SUCCESS,
    payload: { vpId, shareKey },
});
